'use strict';

const { h } = require('phy');
const alphaList = require('../../support/alpha-numeric')();

function BrowseByMerchant({ merchants, routes }) {
  return h(
    '.browse-merchant',
    merchants.map(
      (list, index) =>
        list.length > 0 &&
        h(
          '.browse-merchant-group',
          { id: alphaList[index] },
          h('h3.browse-merchant-title', alphaList[index]),
          h(
            'ul.browse-merchant-list',
            {
              'data-bhw': 'BrowseMerchant',
            },
            list.map(({ merchantSlug, merchantName }) =>
              h(
                'li.browse-merchant-item',
                h(
                  'a.browse-merchant-link',
                  {
                    href: routes.merchant.show.replace(
                      '{merchantSlug}',
                      merchantSlug
                    ),
                    'data-bhc': `store:${merchantSlug}`,
                  },
                  merchantName
                )
              )
            )
          )
        )
    )
  );
}

module.exports = BrowseByMerchant;
